module.exports = __webpack_public_path__ + "8b60c731da3921110707182edbe4e2b6.png";